module.exports = __webpack_public_path__ + "a20231a08414af1c4ee8aca4753c1f2a.wav";